import styled from "styled-components";
import { AppLinkageItem } from "../../molecules/coupon/AppLinkageItem";
import { AppLinkageFooter } from "../../organisms/AppLinkageFooter";
import { AppLinkageForm } from "../../organisms/form/AppLinkageForm";
import { useAppLinkage } from "./hook";

export const AppLinkage: React.FC = () => {
  const { handleAppLinkage, handleReturn } = useAppLinkage();

  return (
    <Container>
      <Title>アプリクーポン利用</Title>

      <Description>
        アプリクーポンが取得できませんでした
        <br />
        <br />
        アプリ会員IDとパスワードを入力し
        <br />
        「クーポン取得」を押していただくことで
        <br />
        アプリクーポンの取得ができます。
      </Description>

      <InputContainer>
        <AppLinkageForm handleSubmit={handleAppLinkage} />
      </InputContainer>

      <Title>アプリ会員IDの確認方法</Title>

      <AppLinkageItem index={1} title="アプリを起動します" />

      <AppLinkageItem index={2} title="ホームからマイページへ" />

      <AppLinkageItem index={3} title="マイページ上部のIDを確認" />

      <AppLinkageFooter onReturn={handleReturn} />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  max-width: 600px;
  min-width: 300px;
  margin: 0 auto;
`;

const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  margin: 16px 0;
`;

const Description = styled.div`
  font-size: 14px;
  text-align: center;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin: 20px 0;
  width: 100%;
`;
